"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _setAttendeeCameraStatus = _interopRequireDefault(require("../../../actions/attendee/setAttendeeCameraStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function attendeeCameraRemoved(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var attendeeId = _ref2.attendeeId,
    isCameraOn = _ref2.isCameraOn;
  dispatch((0, _setAttendeeCameraStatus["default"])(attendeeId, isCameraOn));
}
var _default = exports["default"] = attendeeCameraRemoved;